export default "__VITE_ASSET__1c821c74__"